import { Directive } from '@angular/core';

@Directive({
  selector: '[onrsrClickStopPropagation]',
  host: {
    '(click)': 'onClick($event)'
  }
})
export class ClickStopPropagation {
  onClick(event: Event): void {
    event.stopPropagation();
  }
}
